var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-0 elevation-0"},[_c('v-card-title',{class:`coolgray--text body-2 font-weight-${_vm.selected ? 'bold' : 'medium'} py-0`,on:{"click":_vm.filterByVoter}},[_vm._v(" "+_vm._s(_vm.user.email)+" ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }